import React, {FC} from 'react';
import styled from 'styled-components';

import {hoverSelector} from '../../../../libs/shared/core/src/helpers/browser/hoverHelpers';
import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {PaletteColorsEnum} from '../../../../libs/shared/core/src/models/api/paletteModel';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {ButtonContent} from '../../../../libs/shared/ui/src/components/buttons/buttonContent';
import {ChromelessButton} from '../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';
import {StartGuideProgressBar} from '../../startGuide/startGuideProgressBar';
import {SetupGuideScreenProgress} from '../tasks/onboardingTypes';

/*
 * Style.
 */

const StyledButton = styled(ChromelessButton)`
  // Disable drag in Electron.
  -webkit-app-region: no-drag;

  border-radius: 100px;
  overflow: hidden;
`;

const StyledButtonContent = styled(ButtonContent)`
  padding: 0 14px;
  color: ${(p) => p.theme.topBar.buttonColor};
  background-color: transparent;

  ${hoverSelector} {
    color: ${(p) => p.theme.topBar.buttonHoverColor};
    background-color: ${(p) => p.theme.topBar.buttonHoverBackground};
  }
`;

const StyledLabelContainerDiv = styled.div`
  height: 32px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
`;

const StyledLabelDiv = styled.div`
  ${ellipsis(true)};
`;

/*
 * Props.
 */

interface SetupGuideTopBarButtonProps {
  className: string | undefined;
  onClick: () => void;
  taskProgress: SetupGuideScreenProgress;
  tasksAreComplete: boolean;
}

/*
 * Component.
 */

export const SetupGuideTopBarButton: FC<SetupGuideTopBarButtonProps> = (props) => {
  const {className, onClick, taskProgress, tasksAreComplete} = props;
  return (
    <StyledButton className={className} onClick={onClick}>
      <StyledButtonContent
        size={VisualSizesEnum.MEDIUM}
        variant={ButtonVariantsEnum.CUSTOM}
        color={PaletteColorsEnum.GREY}
        isRounded
      >
        <StyledLabelContainerDiv>
          <StyledLabelDiv>
            <Trans id="setup-guide-topbar-button-label">Setup guide</Trans>
          </StyledLabelDiv>
          {!(taskProgress.hasCompletedAllTasks || tasksAreComplete) && (
            <StartGuideProgressBar
              completedSteps={taskProgress.completedSteps}
              totalSteps={taskProgress.totalSteps}
              hasCompletedAllTasks={taskProgress.hasCompletedAllTasks}
            />
          )}
        </StyledLabelContainerDiv>
      </StyledButtonContent>
    </StyledButton>
  );
};
